import { action, observable, runInAction } from 'mobx';

import worklensClient from '../clients/WorklensClient';

export default class FeatureFlagsStore {
  @observable flags: { [s: string]: boolean } = {};
  @observable hasLoaded: boolean = false;

  @action
  async fetchFlags() {
    try {
      const { flags } = await worklensClient.getFeatureFlags();
      runInAction(() => {
        this.flags = flags;
        this.hasLoaded = true;
      });
    } catch (e) {
      // tslint:disable-next-line:no-console
      console.error('error when fetching from worklens', e);
    }
  }
}
